import { Link, useNavigate } from 'react-router-dom';

export default function ForbiddenPage() {
  const navigate = useNavigate();

  return (
    <div className='min-h-[calc(100vh-48px)] flex items-center justify-center px-4 py-16'>
      <div className='w-full max-w-[560px] rounded-2xl border border-apple-border bg-white px-8 py-10 shadow-card-sm text-center'>
        <p className='text-apple-blue text-[0.75rem] font-semibold uppercase tracking-[0.16em] mb-3'>403</p>
        <h1
          className='font-semibold text-apple-near-black mb-3'
          style={{ fontSize: '2rem', lineHeight: 1.1, letterSpacing: '-0.02em' }}
        >
          无权限访问
        </h1>
        <p className='text-apple-gray max-w-[420px] mx-auto' style={{ fontSize: '0.9375rem', lineHeight: 1.6 }}>
          你当前账号没有访问该资源的权限，可以返回上一页或回到首页继续浏览。
        </p>

        <div className='mt-8 flex flex-col sm:flex-row gap-3 justify-center'>
          <button type='button' className='btn btn-primary' onClick={() => navigate(-1)}>
            返回上一页
          </button>
          <Link to='/' className='btn btn-secondary'>
            返回首页
          </Link>
        </div>
      </div>
    </div>
  );
}